
import { Component, Vue } from "vue-property-decorator";
import NiceButton from "../UI/NiceButton.vue";
import Icon from "../UI/Icon.vue";

@Component({
  components: {
    Icon,
    NiceButton
  }
})
export default class AINoApiKey extends Vue {}
